<template>
  <el-form-item
    ref="baseFormItemRef"
    class="base-form-item"
    :class="{ 'show-label-tips': !!labelTips || isShowDefaultValueConfig }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- label -->
    <template slot="label">
      <div
        class="base-form-item__lalel"
        :class="{ 'multi-line': _label.length > 1 }"
      >
        <div>
          <p v-for="i in _label" :key="i">{{ i }}</p>
        </div>
        <!-- * icon -->
        <i v-if="isShowRequiredIcon" class="base-form-item__requiredIcon">*</i>
      </div>
      <!-- 字段说明 -->
      <BaseTipPopover 
        v-if="labelTips" 
        popperClass="base-form-item__labelTips"
        :width="labelTipsWidth || '460px'" 
        :offset="84"
        :title="labelTitle || label"
        :content="labelTips" 
        :placement="labelTipsPlacement"
      >
        <slot name="labelTipsContent" />
      </BaseTipPopover>
      <!-- 默认值配置 -->
      <DefaultValueConfig
        v-if="isShowDefaultValueConfig"
        :config="valueConfig"
      />
      <!-- new icon -->
      <img 
        v-if="isShowNewIcon" 
        class="base-form-item__lalel__new" 
        :src="require('@@/assets/img/icons/icon_new.png')" 
      />
      <!-- 扩展内容 -->
      <slot name="labelExtend" />
    </template>
    <!-- 内容 -->
    <div
      class="base-form-item__content"
      :class="{ 'fill-tips': !!fillTips, 'is-error': isError || isErrorBlink, 'is-error-blink': isErrorBlink, 'is-shake': isShake }"
    >
      <!-- 内容 -->
      <slot />
      <!-- 单位 -->
      <span v-if="unit" class="base-form-item__content__unit">
        {{ unit }}
      </span>
    </div>
    <!-- 图片/示例 -->
    <div class="base-form-item__other">
      <slot name="other" />
    </div>
    <!-- 扩展内容 -->
    <slot name="extend" />
    <!-- <div v-if="isError" class="base-form-item__error">
      {{ isError }}
    </div> -->
  </el-form-item>
</template>

<script>
import { isPcbOrder } from '@@/utils/is'
// 字段默认值配置组件
import DefaultValueConfig from '@@/components/defaultValueConfig/index.vue'

export default {
  name: 'BaseFormItem2',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelTitle: {
      type: String,
      default: ''
    },
    labelTips: {
      type: String,
      default: ''
    },
    labelTipsWidth: {
      type: String,
      default: ''
    },
    labelTipsPlacement: {
      type: String,
      default: 'top-start'
    },
    isShowLabelTips: {
      type: Boolean,
      default: false
    },
    // 是否显示必填icon * 
    isShowRequiredIcon: {
      type: Boolean,
      default: false
    },
    // 是否显示 new icon
    isShowNewIcon: {
      type: Boolean,
      default: false
    },
    // 单位
    unit:{
      type: String,
      default: ''
    },
    // 未填提示
    fillTips: {
      type: Boolean,
      default: false
    },
    // 校验错误提示
    isError: {
      type: Boolean,
      default: false
    },
    // 错误样式闪两下
    isErrorBlink: {
      type: Boolean,
      default: false
    },
    // 是否抖动两下
    isShake: {
      type: Boolean,
      default: false
    },
    // 设置默认值的相关配置
    valueConfig: {
      type: [String, Object],
      default: ''
    }
  },
  components: {
    DefaultValueConfig
  },
  computed: {
    _label() {
      let label = this.label.split('\n')
      return label.map(t => t.trim())
    },
    // 是否显示默认值配置
    isShowDefaultValueConfig() {
      const isLogin = this.$store.state.orderUser.isLogin
      return isLogin && isPcbOrder() && !!this.valueConfig
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.base-form-item {
  margin-bottom: 14px;
  ::v-deep {
    .el-form-item__label {
      padding-right: 0px;
      font-size: $--font-size-base;
      color: $--color-text-primary;
      .base-tip-popover__icon,
      .default-value-config__icon,
      .base-form-item__lalel__new {
        margin-left: 5px;
      }
      .default-value-config__icon {
        margin-right: 0;
      }
    }

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      font-size: $--font-size-base;
    }
  }
  &.show-label-tips ::v-deep .el-form-item__label {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // .base-form-item__lalel {
    //   margin-right: 5px;
    // }
  }

  .base-form-item__lalel__new {
    display: block;
    width: 29px;
  }

  .base-form-item__lalel {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: $--color-text-important;
    &.multi-line {
      font-size: 12px;
      line-height: 16px;
    }
    .base-form-item__requiredIcon {
      margin-left: 4px;
      color: $--color-danger;
    }
  }

  .base-form-item__content {
    &.fill-tips {
      position: relative;
      margin: -5px;
      margin-right: 0;
      padding: 5px;
      border-radius: 5px;
      background-color: $--tips-background-color;
      &::before {
        position: absolute;
        top: -2px;
        left: -2px;
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #C08534;
      }
    }
    &.is-error {
      position: relative;
      margin: -5px;
      margin-right: 0;
      padding: 5px;
      border-radius: 5px;
      background-color: #FEF0F0;
      &::before {
        position: absolute;
        top: -2px;
        left: -2px;
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: $--color-danger;
        box-shadow: 0 0 5px $--color-danger;
        animation: pulse 1.2s infinite;
      }
      &.is-shake {
        // 抖动动画
        @include shakeAnimation;
      }
    }
    // 闪两下
    @keyframes blink {
      0% {
        border-color: rgba($color: $--color-danger, $alpha: 1.0);
        background-color: rgba($color: #fef0f0, $alpha: 1.0);
      }
      50% {
        border-color: rgba($color: $--color-danger, $alpha: 0);
        background-color: rgba($color: #fef0f0, $alpha: 0);
      }
      100% {
        border-color: rgba($color: $--color-danger, $alpha: 1.0);
        background-color: rgba($color: #fef0f0, $alpha: 1.0);
      }
    }
    // 错误红点闪烁
    @keyframes pulse {
      0% {
        transform: scale(.95);
        box-shadow: 0 0 #ff4d4fb3;
      }
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px #ff4d4f00;
      }
      to {
        transform: scale(.95);
        box-shadow: 0 0 #ff4d4f00;
      }
    }
    &.is-error-blink {
      animation: blink .8s linear .8s 2;
    }
    .base-form-item__content__unit {
      margin-left: 7px;
      color: $--color-text-placeholder;
    }
  }

  .base-form-item__other {
    margin-left: 10px;
    &::v-deep {
      img {
        margin-left: 8px;
        height: 32px;
        vertical-align: top;
      }
    }
  }

  .base-form-item__error {
    width: 100%;
    font-size: 12px;
    color: $--color-danger;
  }
}
</style>

<style lang="scss">
.base-form-item__labelTips {
  .label-tips-img {
    margin: 20px 0 10px;
    text-align: center;
    >img {
      display: inline-block;
    }
  }
}
</style>